import { getTotal } from "./utils";

export const featureFormat = ({ report }) => [
  {
    id: "ff_type",
    chartBlock: {
      title: "SERP Feature Result Type",
      description:
        "This section shows participation in various Google search result features like Image Carousel, Product listings, and Featured Snippets. Higher counts indicate stronger presence in enhanced search results that typically drive more clicks. Features with lower participation represent opportunities to optimize content for these special result types, which often achieve higher visibility and click-through rates.",
      cols: ["Feature", "Count", "% share"],
      fields: ["feature", "count", "share"],
      sortField: "count",
      sortOrder: -1,
      footer: [
        "Grand Total",
        getTotal({ report, sheet: "ff_type", field: "count" }),
      ],
    },
  },
  {
    id: "ff_owned",
    chartBlock: {
      title: "Owned SERP Features",
      description: `This view shows which search result features are currently being captured and how many are owned versus available. The "Client Owned" column indicates current achievements, while the total count shows the full opportunity. Features with low ownership percentages represent areas where optimization efforts could yield significant improvements in search visibility and traffic quality.`,
      cols: ["Feature", "Count", "Client Owned"],
      fields: ["feature", "count", "client_owned"],
      sortField: "client_owned",
      sortOrder: -1,
      swap: 1,
      footer: [
        "Grand Total",
        getTotal({ report, sheet: "ff_owned", field: "count" }),
        getTotal({ report, sheet: "ff_owned", field: "client_owned" }),
      ],
    },
  },
  {
    id: "ff_competitor",
    chartBlock: {
      title: "Top SERP Features Owned By Competitor",
      description:
        "This section reveals how search result features are distributed among competitors, showing each competitor's share of special search result placements. Competitors with higher percentages are capturing more enhanced search visibility, while lower percentages indicate opportunities to compete for these valuable positions through targeted optimization of content for specific feature types.",
      cols: ["website", "% share"],
      fields: ["website", "share"],
      sortField: "share",
      sortOrder: -1,
      // container: true,
    },
  },
];
